import { render } from "./ProductTelescopicView.vue?vue&type=template&id=dcc049c8&ts=true"
import script from "./ProductTelescopicView.vue?vue&type=script&lang=ts"
export * from "./ProductTelescopicView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__